import { Button, Typography } from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import React from "react";
import PropTypes from "prop-types";

import { BadgeButton } from "../BadgeButton/BadgeButton";

import { useStyles } from "./ListItem.styles";

const ListItem = ({
  label,
  del,
  detail,
  redirect,
  isBadgeEnabled,
  isDeleteEnabled,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.listItem} id="listItem">
      <Typography
        variant="body2"
        className={`${classes.listname} ${redirect ? classes.hover : ""}`}
        onClick={() => {
          if (redirect) {
            detail();
          }
        }}
      >
        {label}
      </Typography>
      <div className={classes.listBtnGrp}>
        {isBadgeEnabled && (
          <BadgeButton
            hoverEffect={false}
            type={"quaternary"}
            label={"value"}
          ></BadgeButton>
        )}

        {isDeleteEnabled && (
          <Button
            color="primary"
            disableRipple
            className={classes.delete}
            onClick={del}
          >
            <DeleteOutline></DeleteOutline>
          </Button>
        )}
      </div>
    </div>
  );
};

ListItem.defaultProps = {
  redirect: true,
  isBadgeEnabled: false,
  isDeleteEnabled: true,
};

ListItem.propTypes = {
  label: PropTypes.string,
  del: PropTypes.func,
  detail: PropTypes.func,
  redirect: PropTypes.bool,
  isBadgeEnabled: PropTypes.bool,
  isDeleteEnabled: PropTypes.bool,
};

export { ListItem };
